module.exports = __webpack_public_path__ + "static/slide1-3e9668797ebb9228627041a5409a3680.png";